import { render } from "./AddXyWorkHis.vue?vue&type=template&id=1947f38e"
import script from "./AddXyWorkHis.vue?vue&type=script&lang=js"
export * from "./AddXyWorkHis.vue?vue&type=script&lang=js"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__